import React from 'react';
import { Link } from 'react-router-dom';
import './homepage.css';

function HomePage() {
  return (
    <div className="home-page">
      <div className="hero-section">
        <h1>Welcome to Smart AI Tutor</h1>
        <p>Your personalized learning companion</p>
      </div>
      
      <div className="mode-cards">
        <Link to="/teaching" className="mode-card">
          <div className="card-icon">🎓</div>
          <h2>Teaching Mode</h2>
          <p>Step-by-step structured learning with AI guidance</p>
          <button className="card-button">Start Learning</button>
        </Link>
        
        <Link to="/doubt-solving" className="mode-card">
          <div className="card-icon">❓</div>
          <h2>Doubt Solving</h2>
          <p>Ask questions and get instant AI-powered answers</p>
          <button className="card-button">Ask Doubts</button>
        </Link>
      </div>
    </div>
  );
}

export default HomePage;